export default __webpack_public_path__ + "de1aaf0bf92fd88b16d5a39ed3e2ec05.png";